import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "ascendance-cookie-consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(KEY);
    if (!consent) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[55] backdrop-blur-xl bg-surface/90 border border-white/10 p-6"
        >
          <p className="overline mb-3">Privacy Notice</p>
          <p className="text-sm text-textmuted leading-relaxed mb-5">
            We use cookies to analyze site traffic and optimize your experience. Your data
            is handled in accordance with defense-grade privacy standards.
          </p>
          <div className="flex gap-3">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("accepted")}
              className="btn-tactical flex-1 !px-4 !py-3"
            >
              Accept
            </button>
            <button
              data-testid="cookie-decline"
              onClick={() => decide("declined")}
              className="btn-ghost-tactical flex-1 !px-4 !py-3"
            >
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
